import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import Axios from "axios";

const routePrefix = "/document/";

const DocumentApi = {
	getContent(dossierId, tabName) {
		const serviceUrl = prependRoot(routePrefix + dossierId + "/" + tabName, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	getVoortgangsrapportContent(voortgangsrapportId, tabName) {
		const serviceUrl = prependRoot(routePrefix + "/voortgangsrapport/" + voortgangsrapportId + "/" + tabName, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	getContentByComponent(dossierId, tabName, component) {
		const serviceUrl = prependRoot(routePrefix + dossierId + "/" + tabName + "/" + component, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	getSjablonen(tabName) {
		const serviceUrl = prependRoot(routePrefix + "/sjablonen/" + tabName, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	getVoortgangsrapportSjablonen(tabName) {
		const serviceUrl = prependRoot(routePrefix + "/sjablonen/voortgangsrapport/" + tabName, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	getInfrastructuurContent(dossierId, tabName, infrastructuurId) {
		const serviceUrl = prependRoot(routePrefix + dossierId + "/infrastructuur/" + infrastructuurId + "/" + tabName, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	getFinancierContent(dossierId, tabName, financierId) {
		const serviceUrl = prependRoot(routePrefix + dossierId + "/financier/" + financierId + "/" + tabName, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	uploadDocument(dossierId, tabName, componentName, data) {
		const serviceUrl = prependRoot(routePrefix + "/dossier", getApiRoot());
		data.append("dossierId", dossierId);
		data.append("tabName", tabName);
		data.append("componentName", componentName);

		let returnValue = Axios.put(serviceUrl, data, {
			headers: {
				'accept': 'application/json',
				'Accept-Language': 'ne-nl,en;q=0.8',
				'Content-Type': `multipart/form-data; boundary=${data._boundary}`
			}
		});
		return returnValue;
	},
	uploadVoortgangsrapportDocument(voortgangsrapportId, tabName, componentName, data) {
		const serviceUrl = prependRoot(routePrefix + "/voortgangsrapport", getApiRoot());
		data.append("voortgangsrapportId", voortgangsrapportId);
		data.append("tabName", tabName);
		data.append("componentName", componentName);

		let returnValue = Axios.put(serviceUrl, data, {
			headers: {
				'accept': 'application/json',
				'Accept-Language': 'ne-nl,en;q=0.8',
				'Content-Type': `multipart/form-data; boundary=${data._boundary}`
			}
		});
		return returnValue;
	},
	uploadInfrastructuurDocument(dossierId, tabName, componentName, infrastructuurId, data) {
		const serviceUrl = prependRoot(routePrefix + "/infrastructuur", getApiRoot());
		data.append("dossierId", dossierId);
		data.append("tabName", tabName);
		data.append("componentName", componentName);
		data.append("infrastructuurId", infrastructuurId);

		let returnValue = Axios.put(serviceUrl, data, {
			headers: {
				'accept': 'application/json',
				'Accept-Language': 'ne-nl,en;q=0.8',
				'Content-Type': `multipart/form-data; boundary=${data._boundary}`
			}
		});
		return returnValue;
	},
	deleteDocument(dossierId, tabName, componentName, filename) {
		const serviceUrl = prependRoot(routePrefix + dossierId + "/" + tabName + "/" + componentName + "/" + filename, getApiRoot());
		let returnValue = Axios.delete(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	deleteVoortgangsrapportDocument(voortgangsrapportId, tabName, componentName, filename) {
		const serviceUrl = prependRoot(routePrefix + "/voortgangsrapport/" + voortgangsrapportId + "/" + tabName + "/" + componentName + "/" + filename, getApiRoot());
		let returnValue = Axios.delete(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	deleteInfrastructuurDocument(dossierId, tabName, componentName, infrastructuurId, filename) {
		const serviceUrl = prependRoot(routePrefix + dossierId + "/infrastructuur/" + infrastructuurId + "/" + tabName + "/" + componentName + "/" + filename, getApiRoot());
		let returnValue = Axios.delete(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	startFileSession(dossierId, tabName) {
		const serviceUrl = prependRoot(routePrefix + "startfilesession/dossier/" + dossierId + "/" + tabName, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	startInfrastructuurFileSession(dossierId, tabName, infrastructuurId) {
		const serviceUrl = prependRoot(routePrefix + "startfilesession/dossier/" + dossierId + "/infrastructuur/" + infrastructuurId + "/" + tabName, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	endFileSession(dossierId, tabName) {
		const serviceUrl = prependRoot(routePrefix + "endfilesession/dossier/" + dossierId + "/" + tabName, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	endInfrastructuurFileSession(dossierId, tabName, infrastructuurId) {
		const serviceUrl = prependRoot(routePrefix + "endfilesession/dossier/" + dossierId + "/infrastructuur/" + infrastructuurId + "/" + tabName, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	startVoortgangsrapportFileSession(tabName, voortgangsrapportId) {
		const serviceUrl = prependRoot(routePrefix + "startfilesession/voortgangsrapport/" + voortgangsrapportId + "/" + tabName, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	endVoortgangsrapportFileSession(tabName, voortgangsrapportId) {
		const serviceUrl = prependRoot(routePrefix + "endfilesession/voortgangsrapport/" + voortgangsrapportId + "/" + tabName, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	}



	,
	getFile() {
		return null;
	}
};

export default DocumentApi;
